import React, { useState } from "react";
import { withRouter } from "react-router";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { useCancelPendingInvoiceMutattion } from "../../../../api/mutations/useCancelPendingInvoiceMutation";
import { passOr } from "../../../../utilities/general";
import { tCommon } from "../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../services/UINotificationService";
import { history } from "../../../../history";
import classes from "./CancelPendingInvoice.module.scss";

const CancelPendingInvoice = ({
  invoiceId,
  isMerger,
  refetchInvoiceDetails,
  invoiceItems,
}) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const SALES_ROUTE = "/sales/invoices";

  const cancelPendingInvoice = useCancelPendingInvoiceMutattion({
    onError: (e) => {
      uiNotification.error(e.response.data.message);
    },
    onSuccess: () => {
      uiNotification.success("Invoice has been cancelled");
      if (isMerger) {
        history.push(SALES_ROUTE);
      } else {
        refetchInvoiceDetails();
      }
      setIsConfirmModalOpen(false);
    },
  });

  const onCancelInvoice = () => {
    cancelPendingInvoice.mutate({ invoiceId });
  };

  const isEgiftCardInvoice =
    invoiceItems?.length === 1 && invoiceItems[0].product_type === "egiftcard";

  const singleInvoiceMessage = isEgiftCardInvoice
    ? tCommon("confirm.cancelPendingInvoiceDelete")
    : tCommon("confirm.cancelPendingInvoice");

  return (
    <div className={classes.root}>
      <button
        className="red-btn d-flex align-center justify-center gap-4"
        onClick={() => setIsConfirmModalOpen(true)}
        disabled={cancelPendingInvoice.isLoading}
      >
        {passOr(cancelPendingInvoice.isLoading, undefined, () => (
          <CircularProgress color="white" size="tiny" />
        ))}
        {tCommon("label.cancelPendingInvoice")}
      </button>
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onCancel={() => setIsConfirmModalOpen(false)}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={onCancelInvoice}
        isConfirming={cancelPendingInvoice.isLoading}
      >
        {!isMerger
          ? singleInvoiceMessage
          : tCommon("confirm.cancelPendingInvoiceMerger")}
      </ConfirmModal>
    </div>
  );
};

export default withRouter(CancelPendingInvoice);
